import { render } from "./CombinacaoVeiculo.vue?vue&type=template&id=2d3bcc52"
import script from "./CombinacaoVeiculo.vue?vue&type=script&lang=ts"
export * from "./CombinacaoVeiculo.vue?vue&type=script&lang=ts"
script.render = render

export default script